import { z } from 'zod';

export const PayCorrectionAdjustedEmployeeSalaries = z.record(
  z.string(),
  z.number(),
);

export type PayCorrectionAdjustedEmployeeSalaries = z.infer<
  typeof PayCorrectionAdjustedEmployeeSalaries
>;
